import { Form, Modal } from "react-bootstrap";
import React, { useState, useContext } from "react";
import { AuthContext } from "../../AuthProvider";
import Parse from "parse";
import './Mode.css';

const Mode = () => {

    const { esp, updateUserEsp, setUserEsp } = useContext(AuthContext);

    const [modalIsOpen, setModalIsOpen] = useState(false);

    const handleOpenModal = () => {
        setModalIsOpen(true);
    };

    const handleCloseModal = () => {
        setModalIsOpen(false);
    };

    const handleModeChange = (event) => {
        updateUserEsp(esp.id, { heating: { mode: event.target.value } })
            .then((result) => {
                Parse.Cloud.run("updateHeatingSchedule", { espId: esp.id })
                    .then((scheduleResult) => {
                        setUserEsp(scheduleResult)
                    });
            });
        handleCloseModal();
    }

    return (
        <div>
            <div>
                <button onClick={handleOpenModal} className="controlpanel-button">
                    {esp?.heating?.mode === "ECONOMIC" &&
                        <i className="bi bi-thermometer-low controlpanel-button-mode-icon" style={{ color: "#007bff", position: 'absolute', top: '-10%', left: '-15%' }} />
                    }
                    {esp?.heating?.mode === "COMFORT" &&
                        <i className="bi bi-thermometer-half controlpanel-button-mode-icon" style={{ color: "#FFD700", position: 'absolute', top: '-10%', left: '-15%' }} />
                    }
                    {esp?.heating?.mode === "LUX" &&
                        <i className="bi bi-thermometer-high controlpanel-button-mode-icon" style={{ color: "#ff4d4d", position: 'absolute', top: '-10%', left: '-15%' }} />
                    }
                    <span className="controlpanel-button-mode-text" style={{ position: 'absolute', top: '20%', left: '50%' }}>Läge</span>
                    <span className="controlpanel-button-mode-number" style={{ position: 'absolute', bottom: '2%'}}>
                        {esp?.heating?.mode === "ECONOMIC" ? "Ekonomisk" : esp?.heating?.mode === "COMFORT" ? "Bekväm" : "Lyx"}
                    </span>
                </button>
            </div>
            <Modal show={modalIsOpen} onHide={handleCloseModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Uppvärmningsläge</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form className="automation-form">
                        <Form.Group>
                            <div>
                                <Form.Check
                                    label="Ekonomisk"
                                    name="economic"
                                    type="radio"
                                    id="economic"
                                    value="ECONOMIC"
                                    onChange={handleModeChange}
                                    checked={esp?.heating?.mode === "ECONOMIC"}
                                    disabled={esp?.heating?.automationStatus ? false : true}
                                />
                                <Form.Check
                                    label="Bekväm"
                                    name="comfort"
                                    type="radio"
                                    id="comfort"
                                    value="COMFORT"
                                    onChange={handleModeChange}
                                    checked={esp?.heating?.mode === "COMFORT"}
                                    disabled={esp?.heating?.automationStatus ? false : true}
                                />
                                <Form.Check
                                    label="Lyx"
                                    name="lux"
                                    type="radio"
                                    id="lux"
                                    value="LUX"
                                    onChange={handleModeChange}
                                    checked={esp?.heating?.mode === "LUX"}
                                    disabled={esp?.heating?.automationStatus ? false : true}
                                />
                            </div>
                        </Form.Group>
                    </Form>
                    <p>Välj hur jämn temperatur som skall hållas respektive hur mycket pengar du vill spara. Mer svängningar i värmen ger större möjlighet att spara pengar men kan upplevas som mer obekvämt.</p>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default Mode;


